// Copyright (c) 2022-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import React from "react";
import { FacebookPixelUtils } from "../../../../../../io/hyperify/core/facebook/FacebookPixelUtils";
import { Currency } from "../../../../../../io/hyperify/core/types/Currency";
import { isNumber } from "../../../../../../io/hyperify/core/types/Number";
import { useStoreStatistics } from "../../../../../../io/hyperify/frontend/hooks/useStoreStatistics";
import { FACEBOOK_PIXEL_ID } from "../../../../core/constants/ads";
import {
    MAIN_INDEX_VIEW_CLASS_NAME
} from "../../../../core/constants/className";
import { COMPANY_ACTIVE_YEARS } from "../../../../core/constants/company";
import { FacebookPixel } from "../../common/facebookPixel/FacebookPixel";
import { SEOFragment } from "../../common/seo/SEOFragment";
import {
    INDEX_ROUTE,
} from "../../../../core/constants/route";
import {
    T_INDEX_ROUTE_DESCRIPTION,
    T_INDEX_ROUTE_TITLE,
    T_SITE_NAME,
} from "../../../../core/constants/translation";
import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";
import "./MainIndexView.scss";
import { PalvelinkauppaView } from "./palvelinkauppaView/PalvelinkauppaView";

export interface MainIndexViewProps {
    readonly t: TranslationFunction;
    readonly className?: string;
}

export function MainIndexView (props: MainIndexViewProps) {
    const t: TranslationFunction = props.t;
    const statistics = useStoreStatistics();
    const invoiceSum : number = isNumber(statistics?.invoiceSum) ? statistics?.invoiceSum : 0;
    const translationParams = {
        YEARS                 : COMPANY_ACTIVE_YEARS,
        CLIENT_COUNT          : statistics?.clients  ?? 0,
        INVOICE_COUNT         : statistics?.invoices ?? 0,
        PAYMENT_COUNT         : statistics?.payments ?? 0,
        BUSINESS_CLIENT_COUNT : statistics?.businessClients ?? 0,
        PERSONAL_CLIENT_COUNT : statistics?.personalClients ?? 0,
        INVOICE_SUM           : invoiceSum.toFixed(0),
    };
    return (
        <div className={MAIN_INDEX_VIEW_CLASS_NAME}>
            <SEOFragment
                    path={INDEX_ROUTE}
                    title={t(T_INDEX_ROUTE_TITLE, translationParams)}
                    description={t(T_INDEX_ROUTE_DESCRIPTION, translationParams)}
                    siteName={t(T_SITE_NAME)}
            />
            <FacebookPixel url={FacebookPixelUtils.getViewContentURL(FACEBOOK_PIXEL_ID, 0, Currency.EUR )} />
            {/*<AboutView t={t} />*/}
            <PalvelinkauppaView t={t} />
            {/*<IntroView t={t} />*/}
        </div>
    );
}
